import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { SimpleRouterState } from '@platform-frontend/util';
import { SetAuthFormEmail } from './auth-form.actions';

export const AuthFormEmailGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const email: string | null = route.queryParamMap.get('email');
    if (email) {
      store.dispatch(new SetAuthFormEmail(email));
    }
  }

  return true;
};
